import { useFormLayout } from '../../FormLayout/hooks/useFormLayout'
import { BaseFormItemProps } from '../interface'

export const useFormItemLayout = (props: BaseFormItemProps) => {
  const {
    layout = 'horizontal',
    colon,
    feedbackLayout,
    fullness,
    labelAlign = 'right',
    labelWidth,
    labelWrap,
    wrapperWidth,
    wrapperMinWidth
  } = useFormLayout()

  const layoutType = props.layout ?? layout

  return {
    ...props,
    layout: layoutType,
    colon: props.colon ?? colon,
    feedbackLayout: props.feedbackLayout ?? feedbackLayout,
    labelAlign:
      layoutType === 'vertical'
        ? (props.labelAlign ?? 'left')
        : (props.labelAlign ?? labelAlign),
    labelWrap: props.labelWrap ?? labelWrap,
    labelWidth: props.labelWidth ?? labelWidth,
    wrapperWidth: props.wrapperWidth ?? wrapperWidth,
    wrapperMinWidth: props.wrapperMinWidth ?? wrapperMinWidth,
    fullness: props.fullness ?? fullness,
    asterisk: props.asterisk
  }
}
